// const wsBaseHref = process.env.WS_HOST_BASE;
// DEV:
// export const wsBaseHref = 'http://159.149.3.86:9001/api';
// PROD:
export const wsBaseHref = 'https://www.elmariachistudios.it/ws';

// exporting authentication urls
// DEV:
// export const serverUrl = "http://159.149.3.86:9001";
// PROD:
export const serverUrl ="https://www.elmariachistudios.it/"
// DEV:
// export const sdkConfig = {
//   serverUrl: "http://159.149.3.86:8000",
//   clientId: "1ff4ba2eb5b5ebf79044",
//   appName: "pauperleaguemanager",
//   organizationName: "built-in",
//   redirectPath: "/web/callback",
//   signinPath: "/api/signin",
// };
// PROD:
export const sdkConfig = {
  serverUrl: "https://login.elmariachistudios.it",
  clientId: "fa98151e8ccb96f0a3ee",
  appName: "pauperleaguemanager",
  organizationName: "LPMartesana",
  redirectPath: "/callback",
  signinPath: "/signin",
};

// console.warn(process.env.PUBLIC_URL);
export const basepath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}/`
  : '/'; 

export const api = {
  me: () => ({
    href: `${wsBaseHref}/userInfo`,
  }),
  meLogin: () => ({
     href: `${wsBaseHref}/login`,
  }),
  leagues: () => {
    const leagueHref = `${wsBaseHref}/leagues`;
    return {
      detailsById: (id) => ({
        href: `${leagueHref}/${id}`,
      }),
      list: () => ({
        href: leagueHref,
      }),
      getSeasons: (id) => ({
        href: `${leagueHref}/${id}/seasons`,
      }),
    }
  },
  seasons: () => {
      const seasonHRef = `${wsBaseHref}/seasons`;
      return {
        detailsById: (id) => ({
          href: `${seasonHRef}/${id}`,
        }),
        detailsBySlug: (slug) => ({
          href: `${seasonHRef}/${slug}`,
        }),
        list: () => ({
          href: seasonHRef,
        }),
        addStage: (id) => ({
          href: `${seasonHRef}/${id}/createstage`,
        }),
        getStages: (id) => ({
          href: `${seasonHRef}/${id}/stages`,
        }),
        getRanking: (id) => ({
          href: `${seasonHRef}/${id}/ranking`,
        }),
        getMetagame: (id) => ({
          href: `${seasonHRef}/${id}/metagameStats`,
        })
      }
  },
  stages: () => {
    const stagesHref = `${wsBaseHref}/stages`;
    return {
      detailsById: (id) => ({
        href: `${stagesHref}/${id}`
      }),
      players: (id) => ({
        href: `${stagesHref}/${id}/participants`
      }),
      waitlist: (id) => ({
        href: `${stagesHref}/${id}/waitlist`
      }),
      addPlayer: (id) => ({
        href: `${stagesHref}/${id}/addParticipant`
      }),
      removePlayer: (id) => ({
        href: `${stagesHref}/${id}/removeParticipant`
      }),
      setRanking: (id) => ({
        href: `${stagesHref}/${id}/setRanking`
      }),
      subscribe: (id) => ({
        href: `${stagesHref}/${id}/subscribe`
      })
    }
  },
  tournaments: () => {
    const tournamentsHref = `${wsBaseHref}/tournaments`;
    return {
      detailsById: (id) => ({
        href: `${tournamentsHref}/${id}/`
      }),
      list: () => ({
        href: `${tournamentsHref}?upcoming=false`
      }),
      upcoming: () => ({
        href: `${tournamentsHref}?upcoming=true`
      }),
      players: (id) => ({
        href: `${tournamentsHref}/${id}/participants`
      }),
      addTournament: () => ({
        href: `${tournamentsHref}/create`
      }),
      addPlayer: (id) => ({
        href: `${tournamentsHref}/${id}/addParticipant`
      }),
      removePlayer: (id) => ({
        href: `${tournamentsHref}/${id}/removeParticipant`
      }),
      setRanking: (id) => ({
        href: `${tournamentsHref}/${id}/setRanking`
      }),
    }
  },
  rankings: () => {
    const rankHref = `${wsBaseHref}/request/bo/ranking`;
    return {
      list: () => ({
        href: rankHref,
      })
    };
  },
  players: () => {
    const playerHref = `${wsBaseHref}/players`;
    return {
      list: () => ({
        href: playerHref,
      }),
      detailsById: (id) => ({
        href: `${playerHref}/${id}`,
      })
    }
  },
  places: () => {
    const placeHref = `${wsBaseHref}/places`;
    return {
      list: () => ({
        href: placeHref,
      }),
      detailsById: (id) => ({
        href: `${placeHref}/${id}`,
      })
    }
  },
  decks: () => {
    const deckHref = `${wsBaseHref}/decks`;
    return {
      list: () => ({
        href: deckHref,
      }),
      detailsById: (id) => ({
        href: `${deckHref}/${id}`,
      })
    }
  },
  byes: () => {
    const byesHref = `${wsBaseHref}/bye`;
    return {
      list: () => ({
        href: `${byesHref}/list`,
      }),
      detailsById: (id) => ({
        href: `${byesHref}/${id}`,
      })
    }
  }
};